// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MjRum","transparent":"styles_transparent__DWP5l"};